import React, {Fragment, useContext} from "react";
import PropTypes from "prop-types";
import SpinnerDiv from "../Components/SpinnerDiv";
import PassportTable, {xlateBootstrapTableColumns} from "root/Tables/PassportTable";
import phpVars from 'phpVars';

import {
    TableActionIconEdit, TableActionIconView, TableActionIconDelete,
    customHeaderStyle,
    defaultTableHeaderStyles,
    defaultTopLeftCellStyle,
    defaultTopRightCellStyle,
    defaultPaginationOptions, TableActionIconGeneric
} from "root/Tables/BaseTableComponents";

import {PostFilters, PostStatus, UserRoleGroups, UserTypes} from "root/DataFunctions/Constants";
import {currentChildAtom} from "root/recoil/childId";
import {useRecoilValue} from "recoil";
import {getDocumentUrl} from "root/DataFunctions/CommonDataFns";
import {useLocation} from "react-router-dom";
import queryString from "query-string";
import GlobalContext from "root/contexts/GlobalContext";

const PostsTable = (props) => {
    const globals = useContext(GlobalContext);

    const onClickItem = (mode, post_id, child_uid) =>
    {
        props.clickHandler(mode, child_uid, post_id);
    }

    function linkFormatter(cell, row, rowIndex, formatExtraData)
    {
        const currentChild = useRecoilValue(currentChildAtom);
        const isSender = phpVars.unenc_user_id === +(row.unenc_sender_user_id) ? true :false;
        const isDraft = +(row.status) === PostStatus.NOT_SENT;
        const isReturned = +(row.status) === PostStatus.RETURNED;
        const isHeld = +(row.status) === PostStatus.PENDING;
        const isArchived = +(row.status) === PostStatus.HELD;
        const isApproved = +(row.status) === PostStatus.APPROVED;
        const isSubmitted = +(row.status) === PostStatus.NEW;

        const shouldShowEdit = (isDraft ||(isReturned && isSender));
        const shouldShowDelete = (isDraft || isReturned || isSubmitted) && isSender ;

        //Specify if the logged in users can change the status of messages including apporoving and holding
        const isNotReceiver = phpVars.unenc_user_id !== +(row.unenc_recipient_user_id) ? true :false;
        const canChangeStatus = isNotReceiver && currentChild.is_editor;

        return (
            <Fragment>
                {(shouldShowDelete) && <TableActionIconDelete text="Remove" onClick={() => onClickItem( 'delete', row.post_id, row.recipient_user_id)}/>}
                {(shouldShowEdit) && <TableActionIconEdit text="Edit" onClick={() => onClickItem('edit', row.post_id, row.recipient_user_id)}/>}
                {(isSubmitted || isHeld || isArchived) && canChangeStatus && <TableActionIconGeneric icon='icon-components' color='var(--s360-icon-green)' text="Approve" onClick={() => onClickItem('Action', row.post_id)}/>}
                {(isApproved && canChangeStatus) && <TableActionIconGeneric icon='icon-components' color='var(--s360-icon-red)' text="Hold back (the receiver will not be able to see the post)" onClick={() => onClickItem('Hold Back', row.post_id)}/>}
                { <TableActionIconView text="View" onClick={() => onClickItem( 'view', row.post_id, row.recipient_user_id)} />}
            </Fragment>
        );
    }

    function toFromFormatter(cell, row, rowIndex, formatExtraData)
    {
        const postFilterDefault = globals.userType === UserTypes.CHILD ? 'incomming' : 'new';
        const { search } = useLocation();
        const queryParams = queryString.parse(search) ;
        const postFilter = queryParams.type === undefined?postFilterDefault:queryParams.type;
        const loggedInUserIsChild = globals.userType === UserTypes.CHILD;

        //Check we have a posted by and known as
        let posted_by_name = row.posted_by_name !== null && row.posted_by_name !== '' && row.posted_by_name !== undefined ? row.posted_by_name : row.fullName;
        let posted_to_name = row.known_as !== null && row.known_as !== '' && row.known_as !== undefined ? row.known_as : row.toName;

        //If this is post to myself update the names
        if(row.unenc_recipient_user_id === row.unenc_sender_user_id){
            posted_by_name = 'Me';
            posted_to_name = 'Me';
        }

        switch (+row.status)
        {
            case  PostStatus.RETURNED:
                return (
                    <Fragment>
                        <i className="icon icon-question-circle" style={{fontSize: '1.5rem', marginRight: '7px', color: "red"}}/>
                        {loggedInUserIsChild && <span>{posted_by_name}</span>}
                        {!loggedInUserIsChild && <span>From: {posted_by_name} - To: {posted_to_name}</span>}
                    </Fragment>
                );

                break;

            case  PostStatus.APPROVED:
                return (
                    <Fragment>
                        <i className="icon icon-camera" style={{fontSize: '1.5rem', marginRight: '7px', marginBottom: '3px'}}/>
                        {loggedInUserIsChild && postFilter === PostFilters.SENT && <span>To: {posted_to_name}</span>}
                        {loggedInUserIsChild && postFilter !== PostFilters.SENT && <span>From: {posted_by_name}</span>}
                        {!loggedInUserIsChild && <span>From: {posted_by_name} - To: {posted_to_name}</span>}
                    </Fragment>
                );

                break;

            case  PostStatus.NOT_SENT:
                return (
                    <Fragment>
                        <i className="icon icon-edit" style={{fontSize: '1.5rem', marginRight: '7px'}}/>
                        {loggedInUserIsChild && <span>To: {posted_to_name}</span>}
                        {!loggedInUserIsChild && <span>From: {posted_by_name} - To: {posted_to_name}</span>}
                    </Fragment>
                );

                break;

            default:
                return (
                    <Fragment>
                        <i className="icon icon-camera" style={{fontSize: '1.5rem', marginRight: '7px', marginBottom: '3px'}}/>
                        {loggedInUserIsChild && <span>To: {posted_to_name}</span>}
                        {!loggedInUserIsChild && <span>From: {posted_by_name} - To: {posted_to_name}</span>}
                    </Fragment>
                );
        }
    }

    const statusColor = ( status ) =>
    {
        switch ( +status )
        {
            case PostStatus.RETURNED:
                return { color: 'red' };
            case PostStatus.NOT_SENT:
                return { color: 'blue' };
            case PostStatus.NEW:
                return { color: 'blue' };
            case PostStatus.APPROVED:
                return { color: 'green' };
            default:
                return { color: 'blue' };
        }
    }

    const statusText = ( status ) =>
    {
        switch ( +status )
        {
            case PostStatus.RETURNED:
                return 'Returned';
            case PostStatus.NOT_SENT:
                return 'Draft';
            case PostStatus.NEW:
                return 'Submitted';
            case PostStatus.APPROVED:
                return 'Approved';
            case PostStatus.HELD:
                return 'Archived';
            case PostStatus.PENDING:
                return 'Held';
        }
    }

    const statusFormatter = (cell, row, rowIndex, formatExtraData) =>
    {
        const style = statusColor( row.status );
        const text = statusText( row.status );

        return (
            <Fragment>
                <span style={style}>{text}</span><br/>
            </Fragment>
        );
    }

    const imageFormatter = (cell, row, rowIndex, formatExtraData) =>
    {
        const thumbImageUrl = getDocumentUrl(row.image_array[0], 200, true, row.document_array[0]);
        const fullImageUrl = getDocumentUrl(row.image_array[0], null, null, row.document_array[0]);

        return (
            <div className="child-message-image">
                <a href={fullImageUrl} target="_blank">
                    <img className="pic" src={thumbImageUrl} />
                </a>
            </div>
        )
    }

    const headerStyle = customHeaderStyle.bind(null, {
        default: defaultTableHeaderStyles,
        posted_date: {borderRadius: defaultTopLeftCellStyle, width: "8vw"},
        fullName: {width: "auto"},
        title: {width: "auto"},
        post_status_title: {width: "7vw"},
        edit_submit: {borderRadius: defaultTopRightCellStyle, textAlign: 'right', width: "8vw"}
    });

    const headerStyleChild = customHeaderStyle.bind(null, {
        default: defaultTableHeaderStyles,
        posted_date: {borderRadius: defaultTopLeftCellStyle, width: "6vw"},
        fullName: {width: "auto"},
        sender_user_id: {width: "4vw"},
        event_date: {width: "6vw"},
        title: {width: "auto"},
        message: {width: "auto"},
        edit_submit: {borderRadius: defaultTopRightCellStyle, textAlign: 'right', width: "6vw"}
    });

    const getColumns = () => {
        const my_user_type_id = globals.userType;
        let columns = [];

        if(my_user_type_id === UserTypes.CHILD)
        {
            columns = [
                {
                    dataField: "posted_date",
                    text: "Sent On",
                    sort: true,
                    headerStyle: headerStyleChild,

                },
                {
                    dataField: "fullName",
                    text: "From / To",
                    textAlign: "center",
                    formatter: toFromFormatter,
                    headerStyle: headerStyleChild
                },
                {
                    dataField: "sender_user_id",
                    text: "Image",
                    formatter: imageFormatter,
                    headerStyle: headerStyleChild,
                },
                {
                    dataField: "event_date",
                    text: "Event Date",
                    textAlign: "center",
                    headerStyle: headerStyleChild,
                },
                {
                    dataField: "title",
                    text: "Title",
                    textAlign: "center",
                    headerStyle: headerStyleChild,
                    style: {overflow: 'hidden'},
                },
                {
                    dataField: "text",
                    text: "Message",
                    textAlign: "center",
                    headerStyle: headerStyleChild,
                    style: {overflow: 'hidden'},
                },
                {
                    dataField: "edit_submit",
                    text: "Options",
                    textAlign: "right",
                    headerStyle: headerStyleChild,
                    align: 'right',
                    formatter: linkFormatter
                }
            ];
        }
        else{
            columns = [
                {
                    dataField: "posted_date",
                    text: "Sent On",
                    sort: true,
                    headerStyle: headerStyle,

                },
                {
                    dataField: "fullName",
                    text: "From/To",
                    textAlign: "center",
                    formatter: toFromFormatter,
                    headerStyle: headerStyle
                },
                {
                    dataField: "title",
                    text: "Title",
                    textAlign: "center",
                    headerStyle: headerStyle,
                    style: {overflow: 'hidden'},
                },
                {
                    dataField: "post_status_title",
                    text: "Status",
                    textAlign: "center",
                    formatter: statusFormatter,
                    headerStyle: headerStyle
                },
                {
                    dataField: "edit_submit",
                    text: "Options",
                    textAlign: "right",
                    headerStyle: headerStyle,
                    align: 'right',
                    formatter: linkFormatter
                }
            ];
        }

        return columns;
    };

    const translations = xlateBootstrapTableColumns(getColumns());
    const columns = React.useMemo(() => translations, []);

    const thisTableContent = () =>
    {
        return <PassportTable data={props.data} columns={columns} pagination={defaultPaginationOptions}/>
    }

    return props.loading === true ? <SpinnerDiv/> : thisTableContent();
};

export default PostsTable;

PostsTable.propTypes = {
    post_id: PropTypes.string,
    data: PropTypes.array,
    loading: PropTypes.bool
};